import React, { FC, MouseEvent } from "react";

import { useBoolean } from "~/hooks";

import { Icon, IconColorType, IconType, Link } from "~/ui";

type List = {
  href: string;
  label: string;
};

type Props = {
  title: string;
  buttonClassName?: string;
  lists: List[];
  iconColor: IconColorType;
  isDefaultOpen: boolean;
  icon?: IconType;
};

export const Accordion: FC<Props> = ({
  title,
  buttonClassName = "",
  iconColor,
  lists,
  isDefaultOpen = false,
  icon,
}: Props) => {
  const { isChecked, toggle } = useBoolean(isDefaultOpen);

  const handleToggle = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    toggle();
  };

  return (
    <div>
      <button
        type="button"
        className={`flex items-center w-full relative ${buttonClassName}`}
        onClick={handleToggle}
      >
        <Icon
          icon={isChecked ? "ioCaretDown" : "ioCaretForward"}
          size="0.75rem"
          color={iconColor}
          className="shrink-0"
        />
        {icon && (
          <Icon
            icon={icon}
            size="1.1rem"
            color={iconColor}
            className="shrink-0 ml-1.5"
          />
        )}
        <p className="truncate ml-1.5">{title}</p>
      </button>
      {isChecked && (
        <ul className="ml-9 space-y-0.5 mt-0.5">
          {lists.map((list, index) => (
            <li
              key={`${list.href}-${index}`}
              className="px-3 py-1.5 mx-2 rounded-md text-sm text-secondary-600 hover:bg-primary-300 hover:text-secondary-900"
            >
              <Link to={list.href} className="block">
                {list.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
